// A coding agent's own mark (the Mac's AgentMark, BrandMark.swift): Claude's, Gemini's and Pi's in their colours;
// a one-colour mark (Codex's, Copilot's, OpenCode's) takes the ink of what it's on, so it shows on a primary
// button's dark fill; anything else is sparkles in the muted ink.

import { IconSparkles } from '@tabler/icons-react';
import { LOGOS, type LogoName } from './processLogos';
import type { TablerIcon } from './ds';

/** Pi's mark, as pi.dev draws it (its three blocks, cropped to them). */
const PI = {
  vb: '165.29 165.29 469.43 469.43',
  body: '<path fill="#F09082" d="M165.29 165.29H517.36V400H400V282.65H165.29Z"/><path fill="#4D9ABF" d="M165.29 282.65H282.65V400H400V517.36H282.65V634.72H165.29Z"/><path fill="#F1BE58" d="M517.36 400H634.72V634.72H517.36Z"/>',
};

const MARKS: Record<string, LogoName> = { claude: 'claude', codex: 'codex', gemini: 'gemini', copilot: 'copilot', gh: 'copilot', github: 'copilot', opencode: 'opencode' };

function logoOf(id: string, name: string) {
  if (id === 'pi' || name.toLowerCase() === 'pi') return PI;
  const n = name.toLowerCase();
  const key = MARKS[id] ?? (Object.keys(MARKS).find((k) => n.startsWith(k)) as string | undefined);
  return key ? LOGOS[MARKS[key]] : null;
}

/** `fallback`: the icon when the tool has no mark of its own (a sign-in's key, say). */
export function AgentMark({ id, name, size = 16, fallback: Fallback = IconSparkles }: { id: string; name: string; size?: number; fallback?: TablerIcon }) {
  const l = logoOf(id, name);
  if (!l) return <Fallback size={size} stroke={1.5} className="agent-mark" data-none="" aria-hidden />;
  return <svg className="agent-mark" width={size} height={size} viewBox={l.vb} fill="currentColor" aria-hidden="true" dangerouslySetInnerHTML={{ __html: l.body }} />;
}
